import { PureComponent, ReactNode } from "react";
import { Button, Modal } from "../../components";
import { IStoreState } from "../../store/states";
import { DispatchProp } from "react-redux";
import { connectRedux } from '../../helpers/connectRedux'
import { IServiceInfo } from "../../models";
import React from "react";
import { LiteralsService } from "../../services";
import { images } from "../../images";
import StyledDiv from './styles'
import { setIsAlterationsModalOpenAction } from "../../store/actions";
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<any> {
  isAlterationModalOpen: boolean
  serviceInfos: IServiceInfo[] | null
}

class AlterationModal extends PureComponent<IProps> {
  private get modalContent() {
    const { serviceInfos } = this.props

    const serviceInfosWithAlterationMessages = serviceInfos?.filter((serviceInfo) => serviceInfo.alterationMessages.length > 0)

    if (serviceInfosWithAlterationMessages?.length === 0) return null 
    
    return (
      <div className="content">
        {
          serviceInfosWithAlterationMessages?.map((serviceInfo, index) => (
            <div className="alteration" key={`service-alteration-${index}`}>
              <span key={`service-${index}`} className="service-name">
                { serviceInfo.name }
              </span>
              {
                serviceInfo.alterationMessages.map((message, alterationIdx) => (
                  <span key={`message-${alterationIdx}`} className="alteration-text">
                    { message }
                  </span>
                ))
              }
              {
                index < (serviceInfosWithAlterationMessages.length - 1) &&
                <div key={`divider-${index}`} className="divider"></div>
              }
            </div>
          ))
        }
      </div>
    )
  }

  constructor(props: IProps) {
    super(props)
  }

  componentDidUpdate(): void {
  }

  public render() {
    const { isAlterationModalOpen } = this.props
    
    if (!isAlterationModalOpen) return null
    return (
      <Modal isHidden={ false } onOverlayClick={ this.handleClose }>
        <StyledDiv>
          <header className="vertical">
            <img src={images.alteration} alt="alteration" />
            <span>
              { LiteralsService.get('alterations.title', true) }
            </span>
          </header>
          { this.modalContent }
          <footer>
            <Button
              title={ LiteralsService.get('understood') }
              onPress={ this.handleClose }
              upper
              filled
            />
          </footer>
        </StyledDiv>
      </Modal>
    )
  }

  private handleClose = () => {
    const { dispatch } = this.props

    dispatch(setIsAlterationsModalOpenAction(false))
  }

}

const mapStateToProps = ({ newReservation, alterations }: IStoreState) => ({
  isAlterationModalOpen: alterations.isAlterationsModalOpen,
  serviceInfos: newReservation.serviceInfos
})

export default connectRedux(mapStateToProps, AlterationModal)